/* eslint-disable */
import type { AnalyticsMessage } from "../cash/cdpproxy/api/analytics_message.pb";

/** Authenticated request to get data used to build URLs for Trustpilot Business Generated Links. */
export interface GetTrustpilotUrlPayloadRequest {
  utm_source?: string;
}

/**
 * Returns PII of the customer encrypted in a format that matches the
 * Trustpilot business generated link strategy.  `urlEncoded(base64(encrypted(payload)))`
 * https://support.trustpilot.com/hc/en-us/articles/115004145087-Send-invitations-with-Business-Generated-Links-
 */
export interface GetTrustpilotUrlPayloadResponse {
  payload?: string;
}

export interface TriggerCampaignRequest {
  id?: TriggerCampaignRequestId;
  variables?: TriggerCampaignRequestVariable[];
  client_route_url?: string;
}

export enum TriggerCampaignRequestId {
  REPLACE_CARD = "REPLACE_CARD",
  VERIFY_ADDRESS = "VERIFY_ADDRESS",
  CARD_DRAWER = "CARD_DRAWER",
  NEW_CARD = "NEW_CARD",
  PAYCHECKS = "PAYCHECKS",
  ACTIVATE_CARD = "ACTIVATE_CARD",
  WEB_UNSUPPORTED_CONTINUE_IN_MOBILE = "WEB_UNSUPPORTED_CONTINUE_IN_MOBILE",
}

export interface TriggerCampaignRequestVariable {
  name?: string;
  value?: string;
  type?: TriggerCampaignRequestVariableType;
}

export enum TriggerCampaignRequestVariableType {
  STRING = "STRING",
}

export interface TriggerCampaignResponse {
}

/** Looks up experiment values for a namespace. These are defined in Experiments.java. */
export interface GetExperimentsRequest {
  namespace?: string;
}

/**
 * The results are a map of experiment keys to their assignment values.
 * The key is the experiment key, the value is the experiment assignment value.
 */
export interface GetExperimentsResponse {
  experiments?: { [key: string]: string };
}

export interface GetExperimentsResponseExperimentsEntry {
  key: string;
  value: string;
}

export interface CdpTrackEventRequest {
  analytics_messages?: AnalyticsMessage[];
}

export interface CdpTrackEventResponse {
}

export interface GetReceiptRequest {
  token?: string;
  source?: string;
}

export interface GetReceiptResponse {
  payment_history_data?: string;
}

/** Request to refresh cookies - empty request body. */
export interface CookieRefreshRequest {
}

/** Response for cookie refresh operation. */
export interface CookieRefreshResponse {
}

/** The CashFrontendAppService provides publicly accessible RPC endpoints for web clients. */
export interface CashFrontendAppService {
  GetTrustpilotUrlPayload(request: GetTrustpilotUrlPayloadRequest): Promise<GetTrustpilotUrlPayloadResponse>;
  TriggerCampaign(request: TriggerCampaignRequest): Promise<TriggerCampaignResponse>;
  GetExperiments(request: GetExperimentsRequest): Promise<GetExperimentsResponse>;
  CdpTrackEvent(request: CdpTrackEventRequest): Promise<CdpTrackEventResponse>;
  GetReceipt(request: GetReceiptRequest): Promise<GetReceiptResponse>;
  CookieRefresh(request: CookieRefreshRequest): Promise<CookieRefreshResponse>;
}
